(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Expanding-Cards-FRZ"] && !Shopify.designMode) return;
  try {
    
  class ExpandingCards {
    constructor(container) {
      this.container = container;
      this.cards = Array.from(this.container.querySelectorAll('.card'));
      this.init();
      this.setupImagePositioning();
    }

    init() {
      this.cards.forEach(card => {
        card.addEventListener('click', () => this.handleCardClick(card));
      });
    }

    setupImagePositioning() {
      this.cards.forEach(card => {
        const image = card.querySelector('.expanded-image');
        if (image) {
          // Store original dimensions and position
          image.addEventListener('load', () => {
            const rect = image.getBoundingClientRect();
            image.dataset.originalWidth = rect.width;
            image.dataset.originalHeight = rect.height;
          });
        }
      });
    }

    handleCardClick(clickedCard) {
      this.cards.forEach(card => {
        card.classList.remove('expanded');
        card.classList.add('collapsed');
      });
      
      clickedCard.classList.remove('collapsed');
      clickedCard.classList.add('expanded');
      
      // Update image position after transition with adjusted scale for tablets
      const image = clickedCard.querySelector('.expanded-image');
      if (image) {
        requestAnimationFrame(() => {
          const rect = image.getBoundingClientRect();
          const scale = Math.max(
            (rect.width / parseFloat(image.dataset.originalWidth)) * 0.95, // Add 0.95 scale factor
            (rect.height / parseFloat(image.dataset.originalHeight)) * 0.95
          );
          image.style.transform = `translate(-50%, -50%) scale(${scale})`;
        });
      }
    }
  }

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.cards-container');
    if (container) new ExpandingCards(container);
  });

  // Initialize existing sections
  document.querySelectorAll('.cards-container').forEach(container => {
    new ExpandingCards(container);
  });

  } catch(e) { console.error(e); }
})();
})();
